import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { QuantityCounterComponent } from './quantity-counter.component'
import { ReactiveFormsModule } from '@angular/forms'

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [QuantityCounterComponent],
  exports: [QuantityCounterComponent],
})
export class QuantityCounterModule { }
